const InputStyle =
  "text-md bg-neutral-400/5 rounded-xl px-4 py-3 placeholder-opacity-50 focus:outline-none border border-dark dark:border-white !border-opacity-10 focus:!border-opacity-90 w-full";

export default InputStyle;
